// todo move this file to module
export let showUsersOrdersInMainDashboard = {
    '1': 'نمایش در صفحه اول',
    '0': 'مخفی',
}